/* Carry the public report token into Shopify cart attributes without storing PII. */
(function () {
  'use strict';
  var key = 'sovor_report_token';
  var params = new URLSearchParams(window.location.search);
  var incoming = params.get(key);
  if (incoming && /^rt_[A-Za-z0-9_-]{20,100}$/.test(incoming)) {
    try { window.localStorage.setItem(key, incoming); } catch (_) {}
  }
  var token = incoming;
  try { token = token || window.localStorage.getItem(key); } catch (_) {}
  if (!token || !/^rt_[A-Za-z0-9_-]{20,100}$/.test(token)) return;
  function addTokenToForm(form) {
    if (!form || form.querySelector('[name="attributes[protein_report_token]"]')) return;
    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'attributes[protein_report_token]';
    input.value = token;
    form.appendChild(input);
  }
  function prepareCart() {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(addTokenToForm);
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: { protein_report_token: token } }),
      keepalive: true,
    }).catch(function () {});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', prepareCart, { once: true });
  else prepareCart();
  document.addEventListener('submit', function (event) {
    if (event.target && event.target.matches('form[action*="/cart/add"]')) addTokenToForm(event.target);
  }, true);
})();
